import React from 'react';
import { useToast } from '@chakra-ui/react';
import { Toast } from '../components/toast';

export function useAppToast() {
  const toast = useToast();

  return ({
    variant,
    title,
    description,
    duration = 4000,
  }: {
    variant: 'success' | 'error' | 'warning' | 'info';
    title?: string;
    description?: string;
    duration?: number;
  }) => {
    toast({
      status: variant,
      title,
      position: 'bottom',
      duration,
      isClosable: true,
      render: ({ onClose }) => <Toast variant={variant} title={title} description={description} onClose={onClose} />,
    });
  };
}
